/**
 * SwipeTabs の id 生成とスクロール位置の計算。
 *
 * react-refresh の制約 (コンポーネントファイルからコンポーネント以外を export できない) のため、
 * swipe-tabs.tsx とは別ファイルに切り出している。
 */

export const swipeTabId = (idPrefix: string, value: string) => `${idPrefix}-tab-${value}`

export const swipeTabPanelId = (idPrefix: string, value: string) => `${idPrefix}-panel-${value}`

const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max)

/** 横スクロール位置を 0〜(count - 1) の連続値にする。タブ下線を指に追従させるのに使う */
export const progressFromScroll = (scrollLeft: number, panelWidth: number, count: number): number => {
  if (panelWidth <= 0 || count <= 0) return 0
  return clamp(scrollLeft / panelWidth, 0, count - 1)
}

/** 横スクロール位置に最も近いパネルの index */
export const indexFromScroll = (scrollLeft: number, panelWidth: number, count: number): number =>
  Math.round(progressFromScroll(scrollLeft, panelWidth, count))

/**
 * WAI-ARIA の tab パターンのキー操作で移動する先の index。
 * 左右の矢印は端で反対側に回り込む。対象外のキーは null。
 */
export const tabIndexForKey = (key: string, index: number, count: number): number | null => {
  if (count <= 0) return null
  const lastIndex = count - 1
  if (key === 'ArrowRight') return index >= lastIndex ? 0 : index + 1
  if (key === 'ArrowLeft') return index <= 0 ? lastIndex : index - 1
  if (key === 'Home') return 0
  if (key === 'End') return lastIndex
  return null
}
